//import TruckingReactAPI from '../../lib/generated/TruckingReactAPI';
import Swagger from 'swagger-client';
import { handleError, error, receive, request } from '../../lib/Utils';
let api = new Swagger('/api/docs');

export const LOGIN = {
  REQUEST: "LOGIN_REQUEST",
  SUCCESS: "LOGIN_SUCCESS",
  FAILURE: "LOGIN_FAILURE"
};

const requestLogin = (email) => {
  return { type: LOGIN.REQUEST, email };
};

const loginSuccess = (data) => {
  return { type: LOGIN.SUCCESS, data };
};

export const LOGOUT = {
  REQUEST: "LOGOUT_REQUEST",
  SUCCESS: "LOGOUT_SUCCESS",
  FAILURE: "LOGOUT_FAILURE"
};

export const CUSTOMER_SIGNUP = {
  REQUEST: "CUSTOMER_SIGNUP_REQUEST",
  SUCCESS: "CUSTOMER_SIGNUP_SUCCESS",
  FAILURE: "CUSTOMER_SIGNUP_FAILURE"
};

export const AUTHENTICATED = {
  REQUEST: "AUTHENTICATED_REQUEST",
  SUCCESS: "AUTHENTICATED_SUCCESS",
  FAILURE: "AUTHENTICATED_FAILURE"
};

export const RESET_PASSWORD = {
  REQUEST: "RESET_PASSWORD_REQUEST",
  SUCCESS: "RESET_PASSWORD_SUCCESS",
  FAILURE: "RESET_PASSWORD_FAILURE"
};

export const TOKEN_EXPIRED = {
  REQUEST: "TOKEN_EXPIRED_REQUEST",
  SUCCESS: "TOKEN_EXPIRED_SUCCESS",
  FAILURE: "TOKEN_EXPIRED_FAILURE"
};

export const CONTINUE_AS_GUEST = "CONTINUE_AS_GUEST";

/**
 * Dispatch login request
 * @param {*} email  email - the email for login
 * @param {*} password password the passoword for login
 */
export const login = (email, password, callback = () => false) => {
  return (dispatch) => {
    dispatch(requestLogin(email));
    api.then(client => {
      client.apis.Users.login({
        user: { "email": email, "password": password }
      })
        .then(payload => {
          localStorage.setItem('user_status', true);
          dispatch(loginSuccess(payload.body));
          callback(null);
        }).catch(err => {
          localStorage.setItem('user_status', false);
          //handleError(dispatch, err.response, LOGIN, callback);
          dispatch(error(LOGIN, err.response.body));
          callback(err.response.body);
        });
    }).catch(err => {
      localStorage.setItem('user_status', false);
      dispatch(error(LOGIN, err));
      callback(err);
    });
  };
};

export function continueAsGuest() {
  return {
    type: CONTINUE_AS_GUEST
  };
}

export const resetPassword = (data, callback = () => false) => {

  return (dispatch) => {
    dispatch(request(RESET_PASSWORD));
    return api.then(client => {
      client.apis.Users.resetPassword({
        reset: data
      })
        .then((payload) => {
          dispatch(receive(RESET_PASSWORD, payload.body));
        }).catch(err => {
          dispatch(error(RESET_PASSWORD, err.response.body, callback));
        });
    });



  };
};

export const isTokenExpired = (token, callback = () => false) => {
  return (dispatch) => {

    dispatch(request(TOKEN_EXPIRED));

    return api.then(client => {
      client.apis.Users.isTokenExpired({
        token
      })
        .then((payload) => {
          dispatch(receive(TOKEN_EXPIRED, payload.body));
        }).catch(err => {
          dispatch(error(TOKEN_EXPIRED, err.response.body));
          callback(err.body);
        });
    });

  };
};


export const requestPasswordReset = (data, callback = () => false) => {

  return (dispatch) => {

    dispatch(request(RESET_PASSWORD));

    return api.then(client => {
      client.apis.Users.requestPasswordReset({
        reset: data
      })
        .then((payload) => {
          dispatch(receive(RESET_PASSWORD, payload.body));
        }).catch(err => {
          dispatch(error(RESET_PASSWORD, err.response.body));
          callback(err.body);
        });
    });
  };
};


export const isAuthenticated = () => {
  return (dispatch) => {
    dispatch(request(AUTHENTICATED));

    api.then(client => {
      client.apis.Users.authenticated()
        .then(payload => {
          if (payload.ok) {
            localStorage.setItem('user_status', true);
            dispatch(receive(AUTHENTICATED));
          } else {
            localStorage.setItem('user_status', false);
            dispatch(error(AUTHENTICATED, {
              status: payload.status,
              message: payload.statusText,
            }));
          }
        }).catch((err) => {
          localStorage.setItem('user_status', false);
          dispatch(error(AUTHENTICATED, { status: 0, message: err.message }));
        });
    }).catch(err => {
      localStorage.setItem('user_status', false);
      console.log(err);
    });

  };
};


// WEBPACK FOOTER //
// ./src/containers/Authentication/LoginActions.js